export const SETUP_DISTRAINTS_BY_ID = 'SETUP_DISTRAINTS_BY_ID'
